import {
  Button,
  Card,
  Col,
  Form,
  Input,
  message,
  Row,
  Select,
  Space,
  Spin,
} from 'antd';
import { get } from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import BookingApi from '../../functions/api/booking/BookingApi';
import MarketingLeadApi from '../../functions/api/booking/MarketingLeadApi';
import CityApi from '../../functions/api/partner/CityApi';
import DistrictApi from '../../functions/api/partner/DistrictApi';
import TypeApi, { VEHICLE_TYPES } from '../../functions/api/vehicle/TypeApi';
import VehicleApi from '../../functions/api/vehicle/VehicleApi';
import VehicelNameSearch from '../../views/marketingLead/VehicelNameSearch';
import {
  CustomSelect,
  filterOption,
  normalizeOptions,
} from '../booking/form/CustomSelect';
import DateTimePickerCustom from '../booking/form/DateTimePickerCustom';
import RentPurposeSelect from '../booking/RentPurposeSelect';

const formItemLayout = {
  wrapperCol: { span: 24 },
  labelCol: { span: 24 },
};

const { TextArea } = Input;
const STATUS = [
  {
    value: 'new',
    name: 'NEW',
  },
  {
    value: 'called',
    name: 'CALLED',
  },
  {
    value: 'converted',
    name: 'CONVERTED',
  },
  {
    value: 'failed',
    name: 'FAILED',
  },
];

const RENTAL_TYPES = [
  {
    value: 'short',
    label: 'Ngắn hạn',
  },
  {
    value: 'long',
    label: 'Dài hạn',
  },
];

class FormMarketingLead extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEdit: !!props.match.params.id,
      marketingLead: null,
      cities: [],
      vehicleType: [],
      status: STATUS,
      rental_types: RENTAL_TYPES,
      sources: [],
      districts: [],
      vehicles: [],
      failReason: [],
      vhc_type_id: VEHICLE_TYPES.CAR,
      rental_time: moment(),
      return_time: moment(),
    };
  }

  formRef = React.createRef();

  async componentDidMount() {
    const { match } = this.props;

    if (
      match.params &&
      match.path === '/marketing-lead/edit-marketing-lead/:id'
    ) {
      const { id } = match.params;
      let marketingLead = await MarketingLeadApi.show(id);
      marketingLead = {
        ...marketingLead,
        rental_date: moment(marketingLead.rental_date),
        return_date: moment(marketingLead.return_date),
      };

      await this.loadDistrict(marketingLead.city_id);
      await this.loadVehicle(marketingLead.vhc_type_id);

      this.setState({ marketingLead });
    }

    await this.loadSource();
    await this.loadCity();
    await this.loadVehicleType();
    await this.loadFailReason();
  }

  loadFailReason = async () => {
    const failReason = await MarketingLeadApi.getLeadFailReason();
    this.setState({ failReason });
  };

  loadSource = async () => {
    const sources = await BookingApi.getSources();
    this.setState({ sources });
  };

  loadCity = async () => {
    const cities = await CityApi.getAll();
    this.setState({ cities });
  };

  loadVehicleType = async () => {
    const vehicleType = await TypeApi.getAll();
    this.setState({ vehicleType });
  };

  loadDistrict = async (cityId) => {
    const districts = await DistrictApi.getDistrictByCityId(cityId);
    this.setState({ districts });
  };

  loadVehicle = async (vehicleType) => {
    const vehicles = await VehicleApi.getVehicleByTypeId(vehicleType);
    this.setState({ vehicles });
  };

  handChangeCity = async (cityId) => {
    await this.loadDistrict(cityId);
  };

  handChangeVehicleType = async (vehicleType) => {
    await this.loadVehicle(vehicleType);
    this.setState({ vhc_type_id: vehicleType });
  };

  submitForm = async (values) => {
    try {
      const { isEdit, marketingLead } = this.state;
      values = this.prepareParamForCreate(values);
      let result;
      if (isEdit) {
        result = await MarketingLeadApi.edit(marketingLead.id, values);
      } else {
        result = await MarketingLeadApi.create(values);
      }

      if (result.code && result.code === 'success') {
        message.success(`Đã lưu marketing lead`);
        this.props.history.push('/marketing-lead');
      } else {
        message.error(
          get(
            result,
            'response.data.message',
            'Đã có lỗi xảy ra, vui lòng thử lại'
          )
        );
      }
    } catch (e) {
      console.error(e);
    }
  };

  prepareParamForCreate = (values) => {
    values.district_name = this.getDistrictName(values.district_id);
    values.city_name = this.getCityName(values.city_id);
    values.vhc_name = this.getVhcName(values.vhc_id);
    values.vhc_type_name = this.getVhcTypeName(values.vhc_type_id);

    Object.keys(values).forEach((key) => {
      if (undefined === values[key]) {
        delete values[key];
      }
    });

    return values;
  };

  getDistrictName = (districtId) => {
    const district = this.search(
      'district_id',
      districtId,
      this.state.districts
    );
    return district.district_name ?? '';
  };

  getCityName = (cityId) => {
    const city = this.search('city_id', cityId, this.state.cities);
    return city.city_name ?? '';
  };

  getVhcName = (vhcId) => {
    const vehicle = this.search('vhc_id', vhcId, this.state.vehicles);
    return vehicle.vhc_slug ? vehicle.vhc_slug : '';
  };

  getVhcTypeName = (vhcTypeId) => {
    const vehicleType = this.search(
      'vhc_type_id',
      vhcTypeId,
      this.state.vehicleType
    );
    return vehicleType.vhc_type_name ?? '';
  };

  search = (name, value, array) => {
    for (let i = 0; i < array.length; i++) {
      if (array[i][name] === value) {
        return array[i];
      }
    }

    return {};
  };

  disabledRentalDate = (value) => {
    if (!value) {
      return false;
    }
    return value.isBefore(new Date(), 'date');
  };

  disabledReturnDate = (value) => {
    if (!value) {
      return false;
    }
    return value.isSameOrBefore(this.state.rental_time, 'date');
  };

  render() {
    const {
      isEdit,
      marketingLead,
      cities,
      sources,
      vehicleType,
      status,
      districts,
      failReason,
    } = this.state;

    if (isEdit && !marketingLead) {
      return <Spin />;
    }

    let initialValues;

    if (marketingLead) {
      initialValues = marketingLead;
    } else {
      initialValues = {
        status: 'new',
        rental_date: moment(),
        vhc_type_id: this.state.vhc_type_id,
        rental_type: 'short',
      };
    }

    return (
      <>
        <h2>
          {isEdit
            ? `Sửa thông tin của MKT Lead ${marketingLead.name}`
            : 'Thêm MKT Lead'}
        </h2>
        <Form
          {...formItemLayout}
          className="bg-grey"
          onFinish={this.submitForm}
          ref={this.formRef}
          initialValues={initialValues}
        >
          <Card className="mb-3">
            <Row gutter={16}>
              <Col span={6}>
                <Form.Item
                  name={['name']}
                  label="Tên"
                  rules={[{ required: true }]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name={['phone']}
                  label="Số điện thoại"
                  rules={[{ required: true }]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name={['email']} label="Email">
                  <Input />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={6}>
                <Form.Item
                  name={['source']}
                  label="Nguồn"
                  rules={[{ required: true }]}
                >
                  <CustomSelect
                    dataSource={sources}
                    labelField="book_src_key"
                    valueField="book_src_key"
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name={['city_id']}
                  label="Thành phố"
                  rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    onChange={(value) => this.handChangeCity(value)}
                    filterOption={filterOption}
                    options={normalizeOptions('city_name', 'city_id', cities)}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name={['district_id']} label="Quận">
                  <Select
                    showSearch
                    filterOption={filterOption}
                    options={normalizeOptions(
                      'district_name',
                      'district_id',
                      districts
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name={['vhc_type_id']}
                  label="Loại xe"
                  rules={[{ required: true }]}
                >
                  <Select
                    onChange={(value) => this.handChangeVehicleType(value)}
                  >
                    {vehicleType.map((t) => (
                      <Select.Option key={t.vhc_type_id} value={t.vhc_type_id}>
                        {t.vhc_type_name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Card>
          <Card className="mb-3">
            <Row gutter={16}>
              <Col span={6}>
                <Form.Item
                  name={['rental_type']}
                  label="Loại lead"
                  rules={[{ required: true }]}
                >
                  <Select options={RENTAL_TYPES} />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name={['rental_date']} label="Ngày thuê">
                  <DateTimePickerCustom
                    showTime
                    disabledDate={this.disabledRentalDate}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name={['return_date']} label="Ngày trả">
                  <DateTimePickerCustom
                    showTime
                    disabledDate={this.disabledReturnDate}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name={['vhc_id']} label="Xe">
                  <VehicelNameSearch vehicleType={this.state.vhc_type_id} />
                </Form.Item>
              </Col>
            </Row>
          </Card>
          <Card className="mb-3">
            <Row gutter={16}>
              <Col span={6}>
                <Form.Item name={['renting_purpose']} label="Mục đích thuê">
                  <RentPurposeSelect />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name={['schedule']} label="Lịch trình">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name={['status']}
                  label="Trạng thái"
                  rules={[{ required: true }]}
                >
                  <CustomSelect
                    dataSource={status}
                    labelField="name"
                    valueField="value"
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name={['failure_reason']} label="Lý do fail">
                  <Select
                    showSearch
                    filterOption={filterOption}
                    options={normalizeOptions('reason', 'reason', failReason)}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Card>
          <Card className="mb-3">
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item name={['note']} label="Ghi chú">
                  <TextArea />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name={['call_note']} label="Ghi chú cuộc gọi">
                  <TextArea />
                </Form.Item>
              </Col>
            </Row>
          </Card>
          <Card className="mb-3">
            <Row>
              <Col span={24}>
                <Form.Item name="district_name" hidden>
                  <Input />
                </Form.Item>
                <Form.Item name="city_name" hidden>
                  <Input />
                </Form.Item>
                <Form.Item name="vhc_type_name" hidden>
                  <Input />
                </Form.Item>
                <Form.Item name="vhc_name" hidden>
                  <Input />
                </Form.Item>
                <Space>
                  <Button htmlType="submit" type="primary">
                    Lưu
                  </Button>
                  <Button
                    type="default"
                    onClick={() => this.props.history.push('/marketing-lead')}
                  >
                    Quay lại
                  </Button>
                </Space>
              </Col>
            </Row>
          </Card>
        </Form>
      </>
    );
  }
}

export default withRouter(FormMarketingLead);
